export type ToastVariant = 'error' | 'success' | 'info';

export type ToastEntry = {
  id: string;
  message: string;
  variant: ToastVariant;
};

type ToastListener = (toasts: ToastEntry[]) => void;

const TOAST_DURATION_MS = 6000;

let activeToasts: ToastEntry[] = [];
const listeners = new Set<ToastListener>();

const emit = () => {
  const snapshot = [...activeToasts];
  listeners.forEach((listener) => listener(snapshot));
};

const removeToast = (id: string) => {
  activeToasts = activeToasts.filter((entry) => entry.id !== id);
  emit();
};

export const subscribeToasts = (listener: ToastListener) => {
  listeners.add(listener);
  listener([...activeToasts]);
  return () => listeners.delete(listener);
};

export const pushToast = (message: string, variant: ToastVariant = 'error') => {
  const id = `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
  activeToasts = [...activeToasts, { id, message, variant }];
  emit();
  window.setTimeout(() => removeToast(id), TOAST_DURATION_MS);
};

export const showErrorToast = (message: string) => pushToast(message, 'error');

export const showSuccessToast = (message: string) =>
  pushToast(message, 'success');

export const clearToastsForTests = () => {
  activeToasts = [];
  emit();
};
